"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var taskTemplates;
        (function (taskTemplates) {
            var review;
            (function (review) {
                function init() {
                    addEvents();
                }
                review.init = init;
                function addEvents() {
                    $(document).on('click', '.delete_button', function () {
                        var _a, _b, _c, _d;
                        const presetIdx = (_d = (_c = (_b = (_a = $(this)) === null || _a === void 0 ? void 0 : _a.closest('.fieldTable')) === null || _b === void 0 ? void 0 : _b.attr('id')) === null || _c === void 0 ? void 0 : _c.replace('fields_', appn.emptyString)) !== null && _d !== void 0 ? _d : 0;
                        const dataname = $(this).data('name');
                        $(`#addField_${presetIdx} option[value='${dataname}']`).prop('disabled', false);
                        $(this).parents('tr').remove();
                        renameRows(presetIdx);
                    });
                    $('.addField').on('change', function (event) {
                        var _a, _b, _c;
                        $('.helperText').remove();
                        event.preventDefault();
                        if ($(this).val() === '0')
                            return;
                        const presetIdx = (_c = (_b = (_a = $(this)) === null || _a === void 0 ? void 0 : _a.attr('id')) === null || _b === void 0 ? void 0 : _b.replace('addField_', appn.emptyString)) !== null && _c !== void 0 ? _c : 0;
                        const items = $(`#fields_${presetIdx} tbody`);
                        const idx = items.children().length;
                        const checkBoxId = `Template__Reviewables_${presetIdx}__Fields_${idx}__Required`;
                        const checkBoxId2 = `Template__Reviewables_${presetIdx}__Fields_${idx}__Reviewable`;
                        const thisVal = $(this).val();
                        const newRow = `<tr><td>${thisVal}</td><td>${$(this).find('option:checked').data('qt')}</td><td class="dataCol"><input type="hidden"  name="Template.Reviewables[${presetIdx}].Fields[${idx}].DataName" id="Template__Reviewables_${presetIdx}__Fields_${idx}__DataName" value="${thisVal}"><input type="checkbox" name="Template.Reviewables[${presetIdx}].Fields[${idx}].Required" id=${checkBoxId} value="true"/></td><td class="text-right">${appn.elementBuilder.buildBtnRemoveRow('delete_button', `data-name="${thisVal}"`)}</td></tr>`;
                        $(`#fields_${presetIdx} tbody`).append(newRow);
                        $(`#addField_${presetIdx} option[value='${thisVal}']`).prop('disabled', true);
                        $(`#addField_${presetIdx}`).val('0');
                    });
                }
                function renameRows(presetIdx) {
                    let rowIdx = 0;
                    $('#fields_' + presetIdx + ' tbody tr').each(function (index, row) {
                        $(this).find('input').each(function (index, col) {
                            var _a;
                            let inputName = $(this).attr('name');
                            let inputId = $(this).attr('id');
                            inputName = (_a = inputName === null || inputName === void 0 ? void 0 : inputName.replace(/\.Fields\[[0-9]+\]\./, `.Fields[${rowIdx}].`)) !== null && _a !== void 0 ? _a : appn.emptyString;
                            $(this).attr('name', inputName);
                            if (typeof inputId !== 'undefined') {
                                inputId = inputId.replace(/__Fields_[0-9]+__/, `__Fields_${rowIdx}__`);
                                $(this).attr('id', inputId);
                            }
                        });
                        rowIdx++;
                    });
                }
            })(review = taskTemplates.review || (taskTemplates.review = {}));
        })(taskTemplates = views.taskTemplates || (views.taskTemplates = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
